import { createStyles } from "@material-ui/styles";

export const styles = () =>
  createStyles({
    root: {
      minWidth: "350px !important",
      overflowX: "auto",
    },
  });
